import { memo } from "react";
import { useTranslation } from "react-i18next";
import EngBtn from "svg/icons/EngBtn";
import EspBtn from "svg/icons/EspBtn";

const LangSwitcher = memo(() => {
  const { i18n } = useTranslation();

  const toggle = () => {
    const currentLang = i18n.language;
    if (currentLang === "en") {
      i18n.changeLanguage("es");
    } else {
      i18n.changeLanguage("en");
    }
  };

  const renderButton = () => {
    const currentLang = i18n.language;
    if (currentLang === "en") return <EngBtn />;
    return <EspBtn />;
  };

  return (
    <div>
      <div onClick={toggle} style={{cursor: 'pointer'}}>
        {renderButton()}
      </div>
    </div>
  );
});

export default LangSwitcher;
